import * as React from "react";
const SvgDot = (props) => /* @__PURE__ */ React.createElement("svg", { width: 4, height: 5, viewBox: "0 0 4 5", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 2.03453, cy: 2.1234, r: 1.90856, fill: "currentColor" }));
export default SvgDot;
